export const ChevronUp = ({ className, color = "#d5d5d5", }) => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 11 7", className: className, fill: color },
    React.createElement("path", { fill: color, fillRule: "evenodd", d: "M0 5.663L5.5 0 11 5.663 9.702 7 5.5 2.65 1.298 7z" })));

